import {Component, Input} from "@angular/core";

@Component({
    selector: 'db-waiting-spinner',
    templateUrl: './waiting-spinner.component.html',
    styleUrls: ['./waiting-spinner.component.scss'],
    standalone: false
})
export class WaitingSpinnerComponent {

  @Input() size: Number;
  @Input() centered: boolean;

}
